import React, { forwardRef } from 'react';
import { StyledTextButton, StyledIcon, StyledButtonContent, StyledProgressIndicator } from './index.styles.js';
import {} from '../icon/index.js';
import {} from '../progress-indicator/index.js';
export const TextButton = forwardRef(({ variant, size, label, iconPosition, icon, onClick, type, className, 'aria-label': ariaLabel, 'data-testid': dataTestId, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, disabled, id, isFullWidth, isLoading }, ref) => {
    const iconElement = icon && React.createElement(StyledIcon, { name: icon, size: "s" });
    const progressIndicatorVariant = {
        primary: 'inverted',
        secondary: 'idle',
        tertiary: 'idle'
    };
    return (React.createElement(StyledTextButton, { variant: variant, ref: ref, size: size, isFullWidth: isFullWidth, className: className, "data-testid": dataTestId, "aria-label": ariaLabel, "aria-disabled": disabled, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, onClick: onClick, disabled: disabled, id: id, type: type },
        isLoading && (React.createElement(StyledProgressIndicator, { variant: progressIndicatorVariant[variant], size: "md" })),
        React.createElement(StyledButtonContent, { isLoading: isLoading, "aria-hidden": isLoading },
            iconPosition === 'leading' && iconElement,
            React.createElement("div", null, label),
            iconPosition === 'trailing' && iconElement)));
});
TextButton.displayName = 'TextButton';
//# sourceMappingURL=index.js.map